/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
export type UserContextType = {
  currentUser: any;
  setCurrentUser: React.Dispatch<any>;
};
const UserContext = createContext<UserContextType>({
  currentUser: null,
  setCurrentUser: () => {},
});
export const UserContextProvider = UserContext.Provider;
export default UserContext;
